<template>
  <div class="header">
    <div class="header-left">
      <!-- <img
        :src="logoImg"
        alt="Transit Markets"
        class="logo markets-logo"
        @click="goHome"
      /> -->
      <div class="navbar-logo">
        <img
          class="logo pointer"
          :src="logoImg"
          @click.stop="$router.push('/')"
          @contextmenu.stop="onLogo"
        />
        <div class="brand-kit-wrap" v-if="isBrandKit">
          <div class="brand-kit-item" 
            v-for="(item, index) in brandKitList" 
            :key="index" 
            @click="onBrand(item.url, index)"
          >
            <span :class="[item.class]"></span>
            <span>{{ item.title }}</span>
          </div>
        </div>
      </div>
      <ul class="nav-list">
        <li class="nav-trade">
          <a @click="goSwap" style="cursor: pointer">
            {{ $t('header.trade') }}
          </a>
          <img class="down-img" :src="downImg" alt="">
          <div class="bridge-pop-up-content">
            <NavChildItem  v-for="(item, index) in swapBridgeList" :key="index" :navItem="item" @tap="onNavChild"/>
          </div>
        </li>
        <!-- <li>
          <a @click="goSwap" style="cursor: pointer">
            {{ $t('bridge') }}
          </a>
        </li> -->
        <li class="markets">
          <a @click="goMarkets" style="cursor: pointer">
            {{ $t('header.markets') }}
          </a>
          <!-- <img src="../../assets/header/soon.png" alt="" /> -->
        </li>
        <li class="nav-transit-buy">
          <a
            :href="transitBuyUrl"
            target="_blank"
            >{{ $t('header.buyToken') }}</a
          >
        </li>
        <li class="nav-explorer">
          <a :href="transitExplorerUrl" target="_blank">{{ $t("footer.Features.explorer") }}</a>
        </li>
        <!-- <li class="inscribe-tool">
          <a
            :href="inscribeToolUrl"
            target="_blank"
            >{{ $t('header.inscribeTool') }}</a
          >
        </li> -->
      </ul>
      <div class="search-input-wrap">
        <SearchInput 
          v-if="!isMobileSize"
          :placeholder="$t('searchTokens')" 
          :searchIcon="searchIcon" 
          @focus="onFocus"
        />
      </div>
    </div>

    <SearchToken 
      v-if="$route.path !== '/terms' && $route.path !== '/privacy-policy'" 
      ref="searchToken" 
      :searchIcon="searchIcon" 
      @searchTokensVisible="onFocus"
    />

    <div class="header-right">
      <img
        :src="
          require(`../../assets/header/search/swap-token-search${
            isDarkMode ? '_dark' : ''
          }.png`)
        "
        class="mobile-search"
        :class="{ hidden: $route.path === '/terms' || $route.path === '/privacy-policy' }"
        @click="showSearchTokens"
      />
      <div class="menu-wrap">
        <img class="menu-img" :src="moreImg" @click.stop="onMenu" alt="" />
        <div 
          class="app-settings-panel with-triangle" 
          :class="{ 'app-setting-panel-ani': isAni}" 
          v-if="appSettingsVisible"
        >
          <!-- v-if="appSettingsVisible" -->
          <AppSettingsPanel />
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="searchTokensVisible" 
      custom-class="search-token-dialog"
      top="0"
      :width="tokenModalWidth"
      :lock-scroll="true"
      :center="true"
    >
      <SearchTokenModal 
        :searchTokensVisible="searchTokensVisible" 
      />
    </el-dialog> 
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import tp from 'tp-js-sdk';
import _ from 'lodash';

import Switcher from '../tools/Switcher.vue';
import SearchToken from '../tools/SearchToken.vue';
import AppSettingsPanel from '../tools/AppSettingsPanel.vue';
import NavChildItem from '../header/NavChildItem.vue';
import SearchTokenModal from '../search/SearchTokenModal.vue';
import SearchInput from '../common/SearchInput.vue';
import darkMode from '../../mixins/darkMode';
import link from '../../mixins/link';

export default {
  data() {
    return {
      searchTokensVisible: false,
      appSettingsVisible: false,
      isAni: false,
      isBrandKit: false,
    };
  },
  components: { Switcher, SearchToken, AppSettingsPanel, NavChildItem, SearchTokenModal, SearchInput },
  mixins: [darkMode, link],

  computed: {
    ...mapGetters(['isMobileSize', 'isDarkMode', 'deviceSize']),
    brandKitList() {
      return [
        {
          class: `nav-icon-1${this.darkModeImg}`,
          title: this.$t('brandkit.title'),
          local: true,
          url: '/brandkit'
        },
        {
          class: `nav-icon-2${this.darkModeImg}`,
          title: this.$t('brandkit.download'),
          download: true,
          url: `https://hk.tpstatic.net/transit/brand-kit/brand-kit.zip`
        }
      ]
    },
    tokenModalWidth() {
      if (this.deviceSize !== 'web') {
        return '92%'
      } else {
        return 'auto'
      }
    },
    swapBridgeList() {
      return [
        {
          icon: require(`../../assets/header/Swap&Bridge${this.darkModeImg}.png`),
          title: this.$t('header.bridge'),
          desc:  this.$t('header.bridgeDesc'),
          type: 'bridge'
        },
        {
          icon: require(`../../assets/header/Advanced${this.darkModeImg}.png`),
          title: this.$t('header.advanced'),
          desc:  this.$t('header.advancedDesc'),
          type: 'advanced'
        }
      ]
    },
    searchIcon() {
      return require(`../../assets/header/search/search${this.darkModeImg}.png`);
    },
    inscribeToolUrl() {
      return `https://tp-lab.tokenpocket.pro/insc/?locale=${this.$i18n.locale}&theme=${this.darkModeTheme}#/`
    },
    // transitBuyUrl() {
    //   return `https://buy.transit.finance/?locale=${this.$i18n.locale}&theme=${this.darkModeTheme}`
    // },
    logoImg() {
      return require(`../../assets/home/Transit${this.darkModeImg}.png`);
    },
    moreImg() {
      return require(`../../assets/header/more${this.darkModeImg}.png`);
    },
    downImg() {
        return require(`../../assets/header/down${this.darkModeImg}.png`);
    },
  },
  watch: {
    appSettingsVisible(n) {
      if (n) {
        setTimeout(() => {
          this.isAni = true
        }, 0);
      } else {
        this.isAni = false
      }
    },
    isMobileSize(val) {
      if (val) {
        this.searchTokensVisible = false
      }
    },
  },
  created() {},
  mounted() {
    document.body.addEventListener('click', () => {
      this.appSettingsVisible = false;
      this.isBrandKit = false;
      // this.$store.commit('setAppSettingsVisible', false);
      // this.$store.commit('setMarketSwitchPanelVisible', false);
    });
  },
  methods: {
    onLogo(event) {
      event.preventDefault()
      if (event.button === 0) {
        // console.log('鼠标左键')
        this.$router.push({ path: '/brandkit' })
        this.goHome()
      } else if (event.button === 2) {
        // console.log('鼠标右键')
        this.isBrandKit = !this.isBrandKit
      }
    },
    onBrand(url, index) {
      switch (index) {
        case 0:
          this.$router.push('/brandkit')
          break
        case 1:
          const link = document.createElement('a')
          link.href = url
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          break
        default:
          break
      }
    },
    onTradeMenu(type) {
      this.$store.commit('setShowMenu', false);
      this.$mitt.emit('on-trade-menu', type);
    },
    onNavChild(item) {
      // console.log('location', location);
      // let { origin, pathname, search } = location;
      let url = ''
      if (item.type === 'bridge') {
        url = this.transitBridgeUrl
      } else if (item.type === 'advanced') {
        url = this.transitAdvancedUrl
      }
      window.open(url, '_blank');
      // location.href = `${origin}${pathname}${search}`;
      // onload()
    },
    onFocus() {
      this.searchTokensVisible = true
    },
    onMenu() {
      if (this.isMobileSize) {
        this.$store.commit('setAppSettingDialog', true);
      } else {
        this.appSettingsVisible = !this.appSettingsVisible;
      }
    },
    openContactUs() {
      this.$emit('openContactUs');
    },

    showSearchTokens() {
      this.$mitt.emit("mobile-search-view", true);
    },
    onMobileMenu() {
      this.onSwitchMode();
      this.$store.commit('setShowMenu', false);
    },
    setMarketVisible() {
      this.$store.commit('setMarketVisible', !this.marketVisible);
    },
    onSwitchMode() {
      window.localStorage.setItem('darkmode', !this.isDarkMode ? '1' : '0');
      this.$store.commit('setDarkMode', !this.isDarkMode);
      this.setMode();
    },
    setMode() {
      if (this.isDarkMode) {
        document.documentElement.setAttribute('theme', 'dark');
      } else {
        document.documentElement.removeAttribute('theme');
      }
    },
    switchLang() {
      this.$i18n.locale = this.$i18n.locale === 'zh' ? 'en' : 'zh';
      // this.isShowMenu = false;
      this.$store.commit('setShowMenu', false);
      localStorage.setItem('lang', this.$i18n.locale);
    },
    goHome() {
      if (this.$route.path !== '/') {
        this.$router.push('/');
      }
    },
    goMarkets() {
      window.open(this.swapMarketUrl);
    },
    goSwap() {
      window.open(this.swapUrl);
    },
  },
};
</script>

<style lang="less">
// .loop1(@i) when (@i > 0) {
// @for $i from 1 through 2 {
.loop1(@i) when (@i > 0) {
  .brand-kit-item {
    .nav-icon-@{i} {
      width: 32px;
      height: 32px;
      background: url('../../assets/brand-kit/nav-icon/@{i}.png') no-repeat 100% / contain;
      // background: url(../../assets/brand-kit/nav-icon/@{i}.png)
      //   no-repeat
      //   100% /
      //   contain;
    }
    .nav-icon-@{i}-dark {
      width: 32px;
      height: 32px;
      background: url('../../assets/brand-kit/nav-icon/@{i}-dark.png') no-repeat 100% / contain;
      // background: url(../../assets/brand-kit/nav-icon/@{i}-dark.png)
      //   no-repeat
      //   100% /
      //   contain;
    }
  }
  .brand-kit-item:hover {
    .nav-icon-@{i} {
      background: url('../../assets/brand-kit/nav-icon/@{i}-on.png') no-repeat 100% / contain;
      // background: url(../../assets/brand-kit/nav-icon/@{i}-on.png)
      //   no-repeat
      //   100% /
      //   contain;
    }
    .nav-icon-@{i}-dark {
      background: url('../../assets/brand-kit/nav-icon/@{i}-on.png') no-repeat 100% / contain;
      // background: url(../../assets/brand-kit/nav-icon/@{i}-on.png)
      //   no-repeat
      //   100% /
      //   contain;
    }
  }
  .loop1((@i - 1));
}
.loop1(2);

.header {
  max-width: 1360px;
  margin: 0 auto;
  padding: 0.2rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .header-left {
    display: flex;
    align-items: center;
    flex: 1;
    .logo {
      height: 24px;
      margin: 4px 0 6px 4px;
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
    }

    .navbar-logo {
      display: flex;
      align-items: center;
      // height: 60px;
      position: relative;
      img {
        width: 89px;
        height: 24px;
      }
      .brand-kit-wrap {
        position: absolute;
        z-index: 10;
        left: 0;
        top: 60px;
        background: var(--navbar-wrap-child-language-bg);
        border: 1px solid var(--navbar-wrap-child-language-border);
        border-radius: 12px;
        box-shadow: 0px 6px 16px 0px rgba(45,54,86,0.05); 
        padding: 24px 0;
        display: flex;
        flex-direction: column;
        gap: 24px 0;
        .brand-kit-item {
          display: flex;
          align-items: center;
          gap: 0 24px;
          padding: 0 24px;
          cursor: pointer;
          img {
            width: 32px;
            height: 32px;
          }
          span {
            font-size: 16px;
            font-weight: 500;
            color: var(--color-34);
            white-space: nowrap;
          }
        }
        .brand-kit-item:hover {
          span {
            color: #2980FE;
          }
        }
      }
    }

    .nav-list {
      position: relative;
      top: 1px;
      padding: 0;
      line-height: 40px;
      display: flex;
      margin: 0 8px 0 20px;

      li {
        padding: 0;
        display: flex;
        align-items: center;
        margin: 0 8px;
        a {
          text-decoration: none;
          color: var(--color-1);
          font-size: 15px;
          font-family: PingFang SC, PingFang SC-Medium;
          // font-family: 'Inter-Regular';
          font-weight: 400;
          // cursor: pointer;
          &:hover {
            color: var(--color-5);
          }
        }
        img {
          margin-left: 5px;
          width: 29px;
          height: 14px;
        }
      }

      .nav-trade {
        .down-img {
          width: 14px;
          height: 14px;
        }
        .bridge-pop-up-content {
          display: none;
        }
        &:hover {
          .bridge-pop-up-content {
            display: block;
            width: 350px;
            width: 350px;
            background: var(--bg-40);
            border-radius: 6px;
            border: 1px solid var(--border-19);
            position: absolute;
            z-index: 10;
            left: -20px;
            top: 40px;
            width: 350px;
            box-shadow: 0px 2px 20px 0px rgba(0,0,0,0.15); 
          }
        }
      }
    }
    .search-input-wrap {
      // margin: auto 20px;
      display: none;
      position: relative;
      z-index: 4;
      .search-input {
        width: 432px;
        padding: 0 8px;
        // background: var(--search-input-bg);
        // background: var(--bg-15);
        // border: 1px solid var(--search-input-border);
        border-radius: 8px;
        box-sizing: border-box;
        .input-wrap {
          input {
            &::placeholder {
              color: var(--input-placeholder-1);
              font-size: 14px;
            }
            /*webkit 内核浏览器*/
            &::-webkit-input-placeholder {
              color: var(--input-placeholder-1);
              font-size: 14px;
            }
            /*Mozilla Firefox 19+*/
            &:-moz-placeholder {
              color: var(--input-placeholder-1);
              font-size: 14px;
            }
            /*Mozilla Firefox 4 to 18*/
            &:-ms-input-placeholder {
              color: var(--input-placeholder-1);
              font-size: 14px;
            }
          }
        }
      }
    }
  }
  .header-right {
    display: flex;
    .mobile-search {
      display: none;
    }
    .menu-wrap {
      position: relative;
      display: flex;
      .menu-img {
        width: 0.36rem;
        height: 0.36rem;
        cursor: pointer;
      }
      .app-settings-panel {
        position: absolute;
        top: 45px;
        right: 0;
        min-width: 168px;
        background: var(--wrap-bg);
        box-shadow: 0px 10px 40px 0px rgba(0, 0, 0, 0.2);
        // padding: 16px 20px 15px;
        padding: 12px 12px 16px;
        z-index: 9;
        border-radius: 12px;
        opacity: 0;
        transform: scale(0);
        transform-origin: right top;
        transition: opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1) 0s, transform 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s;
        &.app-setting-panel-ani {
          opacity: 1;
          transform: scale(1);
        }
        &::after {
          right: 10px;
        }
      }
    }
  }
  .nav-list-m {
    .optional-wrap {
      height: 28px;
      display: inline-block;
      .optional-img {
        width: 24px;
        height: 24px;
        vertical-align: middle;
      }
    }
  }
}

@media screen and (max-width: 1430px) {
  .header {
    .header-left {
      flex: 1;
      .search-input-wrap {
        // width: 100%;
        display: flex;
        justify-content: center;
      }
    }
  }
}

@media screen and (max-width: 1500px) {
  .header {
    .header-left {
      flex: 1;
      .search-input-wrap {
        .search-input {
          width: 312px;
        }
      }
    }
  }
}

@media screen and (max-width: 1400px) {
  .header {
    margin: 0 30px;
    .header-left {
      .nav-list {
        .nav-explorer {
          display: none;
        }
      }
    }
  }
}

@media screen and (max-width: 1300px) {
  .header {
    .header-left {
      .nav-list {
        // .inscribe-tool {
        //   display: none;
        // }
        .nav-transit-buy {
          display: none;
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .header {
    .header-left {
      .logo {
        height: 32px;
      }
      .nav-list {
        .markets {
          display: none;
        }
      }
    }
    .header-right {
      .menu-wrap {
        .menu-img {
          width: 40px;
          height: 40px;
        }
      }
    }
  }
}
@media screen and (max-width: 1050px) {
  .header {
    .header-left {
      .nav-list {
        display: none;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .header {
    margin: 0;
    padding: 0.2rem 0.32rem;
    .header-left {
      .nav-list {
        display: none;
      }
      .logo {
        height: 30px;
      }
    }
    .header-right {
      align-items: center;
      .mobile-search {
        display: block;
        margin-right: 16px;
        width: 30px;
        height: 30px;
        &.hidden {
          display: none;
        }
      }
      .menu-wrap {
        .menu-img {
          width: 40px;
          height: 40px;
        }
      }
    }
  }
}
</style>
